import { render, staticRenderFns } from "./Tick.vue?vue&type=template&id=7081efac&scoped=true&"
import script from "./Tick.vue?vue&type=script&lang=js&"
export * from "./Tick.vue?vue&type=script&lang=js&"
import style0 from "./Tick.vue?vue&type=style&index=0&id=7081efac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081efac",
  null
  
)

export default component.exports